import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { Button, Input } from 'semantic-ui-react';
import { useHistory } from 'react-router-dom';
import { H1 } from '../CreateProductPage/CreateProductStyles';
import { SearchInputBlock, ButtonBlock, FooterBlock, CreateUserButton } from './userPageStyles';
import UserParamsBlock, { countryOptions } from './UserParamsBlock';
import * as action from '../../../actions/newYouslim';
import TargetedFitnessFuncBlock from './TargetedFitnessFuncBlock';
import {
  default_activity,
  default_country,
  default_gender,
  product_tags_id,
} from '../youslim2.0_Constants';
import Navbar from '../Navigation/Navbar';
import CoursesBlock from './CoursesBlock';
import debounce from '../../../utils/debounce';
import ConfirmPopup from '../../Common/ConfirmPopup';
import CreateCourseModal from './CreateCourseModal';

const UserPage = React.memo(
  ({
    allTags,
    getProductTags,
    userTarget,
    usersListForSelect,
    updateUser,
    setUserTarget,
    createUser,
    match,
    getUser,
    userInfo,
    getUsersListForSelect,
    updateUserIsPaid,
    updateUserStartDate,
    onUpdateStatusCourse,
  }) => {
    const history = useHistory();
    const [currentUser, setCurrentUser] = React.useState('');
    const [currentUserId, setCurrentUserId] = React.useState(0);
    const [choosedTags, setChoosedTags] = React.useState([]);
    const [usersList, setUsersList] = React.useState([]);
    const [currentGender, setCurrentGender] = React.useState('');
    const [currentActivity, setCurrentActivity] = React.useState('');
    const [currentCountry, setCurrentCountry] = React.useState('');
    const [currentTimezone, setCurrentTimezone] = React.useState('');
    const [deepLink, setDeepLink] = React.useState('');
    const [currentHeight, setCurrentHeight] = React.useState('');
    const [currentWeight, setCurrentWeight] = React.useState('');
    const [currentAge, setCurrentAge] = React.useState('');
    const [currentTargetWeight, setCurrentTargetWeight] = React.useState('');
    const [currentUserName, setCurrentUserName] = React.useState('');
    const [isCreateUser, setIsCreateUser] = React.useState(false);
    const [userCourses, setUserCourses] = React.useState([]);
    const [isShowIsPaidPopup, setIsShowIsPaidPopup] = React.useState(false);
    const [courseId, setCourseId] = React.useState(0);
    const [courseIndex, setCourseIndex] = React.useState(0);
    const [courseStartDate, setCourseStartDate] = React.useState(0);
    const [isCreateCourseModalOpen, setIsCreateCourseModalOpen] = React.useState(false);
    const [isShowIsActiveCourse, setIsShowIsActiveCourse] = React.useState(false);

    React.useEffect(() => {
      getProductTags(product_tags_id, true);

      getUsersListForSelect();
      if (match && match.params && match.params.id) {
        getUser(match.params.id);
      }
    }, []);

    React.useEffect(() => {
      if (match && match.params && match.params.id) {
        getUser(match.params.id);
      }
    }, [match]);

    React.useEffect(() => {
      setUsersList(usersListForSelect);
    }, [usersListForSelect]);

    React.useEffect(() => {
      if (!userInfo.id || !usersList) return;
      const currentUser = userInfo;
      setUsersList([...usersList, { name: currentUser.name, id: currentUser.id }]);
      setCurrentUserId(+currentUser.id);

      setCurrentUser(currentUser.name);

      if (currentUser.params) {
        setUserTarget(currentUser.params);
        setUserCourses(currentUser.courses);
        setChoosedTags(currentUser.black_list_tags.map((tag) => tag.id));
        setCurrentGender(default_gender[currentUser.params.sex_id - 1]);
        setCurrentActivity(default_activity[currentUser.params.activity_id - 1]);
        setCurrentHeight(currentUser.params.height);
        setCurrentCountry(currentUser && currentUser.country && currentUser.country.name);
        setCurrentTimezone(currentUser && currentUser.timezone);
        setDeepLink(currentUser && currentUser.deep_link);
        setCurrentWeight(currentUser.params.weight);
        setCurrentTargetWeight(currentUser.params.weight_target);
        setCurrentAge(currentUser.params.age);
      } else {
        setUserTarget('');
        setChoosedTags([]);
        setCurrentGender('');
        setCurrentActivity('');
        setCurrentHeight('');
        setCurrentWeight('');
        setCurrentTargetWeight('');
        setCurrentAge('');
        setCurrentCountry('');
        setCurrentTimezone('');
        setDeepLink('');
      }
    }, [userInfo]);

    const clearAllFields = React.useCallback(() => {
      setCurrentGender('');
      setCurrentActivity('');
      setCurrentHeight('');
      setCurrentWeight('');
      setCurrentAge('');
      setCurrentCountry('');
      setCurrentTimezone('');
      setDeepLink('');
      setCurrentTargetWeight('');
      setChoosedTags([]);
    }, []);

    React.useEffect(() => {
      clearAllFields();
    }, [isCreateUser]);

    const onChangeUsers = (value) => {
      if (!value) {
        setCurrentUser('');
        return;
      }
      setCurrentUser(value.name);

      history.push(`/youslim2.0/userPage/${value.id}/change`);
    };

    const handleUpdateUserValue = (value) => {
      getUsersListForSelect(value);
    };

    const onUpdateStartDate = (start_date, id, index) => {
      updateUserStartDate(start_date, id, index);
    };

    const onShowUpdateIsPaidPopup = (isPaid, id, index) => {
      setIsShowIsPaidPopup(true);
      setCourseId(id);
      setCourseIndex(index);
    };

    const onUpdateIsPaid = React.useCallback(() => {
      updateUserIsPaid(true, courseId, courseIndex);
      setIsShowIsPaidPopup(false);
    }, [courseId, courseIndex]);

    const onPressUpdateStatusCourse = React.useCallback(() => {
      onUpdateStatusCourse(courseId, courseStartDate, courseIndex, () =>
        setIsShowIsActiveCourse(false),
      );
    }, [courseId, courseStartDate, courseIndex]);

    const setIsShowIsActiveCoursePopup = (start_date, id, index) => {
      setIsShowIsActiveCourse(true);
      setCourseId(id);
      setCourseIndex(index);
      setCourseStartDate(start_date);
    };

    const onParamsSave = () => {
      let currentCountryId = 0;
      countryOptions.map((country) => {
        if (country.value === currentCountry) {
          currentCountryId = country.id;
        }
      });
      updateUser({
        name: currentUser,
        params: {
          sex_id: default_gender.indexOf(currentGender) + 1,
          height: currentHeight,
          weight: currentWeight,
          weight_target: currentTargetWeight,
          age: currentAge,
          activity_id: default_activity.indexOf(currentActivity) + 1,
        },
        tags: choosedTags,
        id: currentUserId,
        tag_country_id: currentCountryId,
      });
    };

    const onCreateUser = () => {
      let currentCountryId = 0;
      countryOptions.map((country) => {
        if (country.value === currentCountry) {
          currentCountryId = country.id;
        }
      });
      createUser(
        {
          name: currentUserName,
          params: {
            sex_id: default_gender.indexOf(currentGender) + 1,
            height: currentHeight,
            weight: currentWeight,
            weight_target: currentTargetWeight,
            age: currentAge,
            activity_id: default_activity.indexOf(currentActivity) + 1,
          },
          tags: choosedTags,
          id: currentUserId,
          tag_country_id: currentCountryId,
        },
        setIsCreateUser,
      );
    };

    const onClickCreateCourseModalOpen = React.useCallback(() => {
      setIsCreateCourseModalOpen(true);
    }, []);

    return (
      <React.Fragment>
        <Navbar> </Navbar>
        <H1>Страница клиентов</H1>
        <SearchInputBlock>
          {!isCreateUser && (
            <Select
              options={usersList}
              clearable
              name="select-user"
              value={currentUserId}
              onChange={onChangeUsers}
              onInputChange={debounce(handleUpdateUserValue, 1000)}
              searchable
              labelKey="name"
              valueKey="id"
              placeholder="Выберите пользователя..."
            />
          )}
          {isCreateUser && (
            <Input
              placeholder="Введите имя нового клиента"
              style={{ width: '100%' }}
              value={currentUserName}
              onChange={(e) => setCurrentUserName(e.target.value)}
            />
          )}
          <CreateUserButton>
            <Button
              color="blue"
              onClick={() => {
                setIsCreateUser(!isCreateUser);
              }}
            >
              {!isCreateUser ? 'Создать нового клиента' : 'Вернуться к просмотру клиента'}
            </Button>
          </CreateUserButton>
        </SearchInputBlock>
        <UserParamsBlock
          allProductsTags={allTags}
          choosedTags={choosedTags}
          setChoosedTags={setChoosedTags}
          params={userTarget}
          currentGender={currentGender}
          setCurrentGender={setCurrentGender}
          currentActivity={currentActivity}
          setCurrentActivity={setCurrentActivity}
          currentHeight={currentHeight}
          setCurrentHeight={setCurrentHeight}
          currentWeight={currentWeight}
          setCurrentWeight={setCurrentWeight}
          currentAge={currentAge}
          setCurrentAge={setCurrentAge}
          currentCountry={currentCountry}
          setCurrentCountry={setCurrentCountry}
          currentTimezone={currentTimezone}
          setCurrentTimezone={setCurrentTimezone}
          deepLink={deepLink}
          setDeepLink={setDeepLink}
          currentTargetWeight={currentTargetWeight}
          setCurrentTargetWeight={setCurrentTargetWeight}
        />
        <TargetedFitnessFuncBlock params={userTarget} />
        {!!userCourses.length && (
          <CoursesBlock
            params={userCourses}
            onUpdateStartDate={onUpdateStartDate}
            onUpdateIsPaid={onShowUpdateIsPaidPopup}
            setIsShowIsActiveCoursePopup={setIsShowIsActiveCoursePopup}
            userId={currentUserId}
          />
        )}
        <ButtonBlock>
          {!isCreateUser && (
            <Button positive onClick={onParamsSave}>
              Сохранить
            </Button>
          )}
          {isCreateUser && (
            <Button positive onClick={onCreateUser}>
              Создать клиента
            </Button>
          )}
          {!!currentUser && (
            <Button color="blue" onClick={onClickCreateCourseModalOpen}>
              Создать курс
            </Button>
          )}
        </ButtonBlock>
        <FooterBlock />
        <ConfirmPopup
          title="Отметить курс как оплаченный?"
          additionalText="Убедитесь что пользователь оплатил курс"
          isShow={isShowIsPaidPopup}
          onApply={onUpdateIsPaid}
          onClose={() => setIsShowIsPaidPopup(false)}
        />
        <CreateCourseModal
          isOpen={isCreateCourseModalOpen}
          onClose={() => setIsCreateCourseModalOpen(false)}
          user={match.params.id}
        />
        <ConfirmPopup
          title="Изменить статус курса на Active?"
          additionalText="Убедитесь что пользователь оплатил курс"
          isShow={isShowIsActiveCourse}
          onApply={onPressUpdateStatusCourse}
          onClose={() => setIsShowIsActiveCourse(false)}
        />
      </React.Fragment>
    );
  },
);

const mapStateToProps = (state) => {
  const {
    allTags,
    usersGeneratedData,
    userTarget,
    usersListForSelect,
    userInfo,
  } = state.newYouslim;
  return {
    allTags,
    usersGeneratedData,
    userTarget,
    usersListForSelect,
    userInfo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getProductTags: (tags, isUserPage) => {
      dispatch(action.getProductTags(tags, isUserPage));
    },
    getUsersListForSelect: (name) => {
      dispatch(action.getUsersListForSelect(name));
    },

    updateUser: (data, id) => {
      dispatch(action.updateUser(data, id));
    },
    setUserTarget: (data) => {
      dispatch(action.setUserTarget(data));
    },
    runGenerator: (data, setIsGenerateRun) => {
      dispatch(action.runGenerator(data, setIsGenerateRun));
    },
    createUser: (data, setIsCreateUserPopup) => {
      dispatch(action.createUser(data, setIsCreateUserPopup));
    },
    getUser: (userId) => {
      dispatch(action.getUser(userId));
    },

    updateUserIsPaid: (is_paid, id, index) => {
      dispatch(action.updateUserIsPaid(is_paid, id, index));
    },
    updateUserStartDate: (updateUserStartDate, id, index) => {
      dispatch(action.updateUserStartDate(updateUserStartDate, id, index));
    },

    onUpdateStatusCourse: (course_id, start_date, index, onClose) => {
      dispatch(action.onUpdateStatusCourse(course_id, start_date, index, onClose));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserPage);



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/UserPage/index.jsx